import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';

const StyledInlineInstallmentCalculator = styled.a`
  cursor: pointer;
  line-height: 1.1rem;
  text-decoration: underline;
  margin: 0;
  width: 100%;
  text-align: center;
  color: #282829;
`;

export interface InlineInstallmentCalculatorProps {
  /** The link content to render. */
  content: JSX.Element | string;
  /**
   * On click handler.
   */
  onClick: () => void;
}

/**
 * This is the installment calculator inline component.
 * By clicking on the component a modalbox opens which enables the user to configure values like the amount of installment rates
 * as well as if a payment pause (if available) should be used. The modalbox also provides a configurable option if the price
 * should be editable or not. If a value changes the installment calculator API will be called again and the values will be
 * updated according to the newly calculated values returned from the API call.
 */
export const InlineElement: FunctionComponent<InlineInstallmentCalculatorProps> = ({
  content,
  onClick,
}): ReactElement => (
  <StyledInlineInstallmentCalculator
    data-testid="inline-installment-calculator-element"
    onClick={() => onClick()}
  >
    {content}
  </StyledInlineInstallmentCalculator>
);

export default InlineElement;
